import React from "react";
import Carousel from "react-bootstrap/Carousel";
import useBusiness from "../../../hooks/useBusiness";
import { isVideov2 } from "../../../helpers/isVideo";

function EmpresaReplicaPGI() {
  const { business } = useBusiness();

  return (
    <>
      <div id="blur-prueba">
        <div className="botton-editar-pginews margin-boton-news">
          <button className=" settings_button-pleno overlay-replica-button">
            {" "}
            <a href="/pgi/edit-empresa">Editar Sección Empresa</a>
          </button>
        </div>
        <section id="institucional__institucional">
          <article
            className="institucional__bg-start align-items-center bg-fullpage"
            aria-label="Presentación de Institucional de Tensolite"
          >
            {isVideov2(business?.imageBusiness?.[0]?.url) ? <video
              src={
                business?.imageBusiness ? business?.imageBusiness?.[0]?.url : ""
              }
              autoPlay
              muted
              loop
            /> : <img
              src={business?.imageBusiness ? business?.imageBusiness?.[0]?.url : ""}
              alt={business?.imageBusiness ? business?.imageBusiness?.[0]?.alt : business?.title}
            />}
            <div className="card-info">
              <div className="cuadrado-azul"></div>
              <h1>{business?.sliderPrimaryDescription}</h1>
            </div>
          </article>

          <article className="container card-info2 institucional__bg-2 col-img-r px-lg-4">
            <div
              role="presentation"
              className="block-img-responsive card-text-2 col-sm-12 col-lg-6"
            >
              <h3 className="text-lg-start text-big">{business?.bannerBusinessTitle}</h3>
            </div>
            <div role="presentation" className="card-text-2 col-sm-12 col-lg-6">
              <p className="text-lg-end text-color">{business?.bannerBusinessDescription}</p>
            </div>
          </article>
        </section>

        <Carousel fade id="institucional__carroussel-mvp" className="carrousel" pause="hover">
          {business?.sliderSecondary?.map((slider, index) => (
            <Carousel.Item id={index} className="block-img-responsive">
              {isVideov2(slider?.imageSliderBusiness?.[0]?.url) ? <video
                className="img-responsive-inter"
                src={
                  slider?.imageSliderBusiness ? slider?.imageSliderBusiness?.[0]?.url : ""
                }
                autoPlay
                muted
                loop
              /> : <img
                className="img-responsive-inter"
                src={slider?.imageSliderBusiness ? slider?.imageSliderBusiness?.[0]?.url : ""}
                alt=""
              />}
              <Carousel.Caption className="card-info">
                <div rol="presentation" className="cuadrado-azul"></div>
                <h2>{slider?.title}</h2>
                <p dangerouslySetInnerHTML={{ __html: slider?.description }}>
                  {/* Somos una organización innovadora, que construye negocios que
                trascienden, impactando positivamente en la sociedad. */}
                </p>
              </Carousel.Caption>
            </Carousel.Item>
          ))}
        </Carousel>

        {/* Seccion de historia */}
        <section id="institucional__historia" className="container d-flex flex-no-wrap ">
          <div className="block-img-responsive col-sm-12 col-md-6 col-lg-6 ">
            {isVideov2(business?.imageBloqueBusiness?.[0]?.url) ? <video
              className="img-responsive zoomOut"
              src={
                business?.imageBloqueBusiness ? business?.imageBloqueBusiness?.[0]?.url : ""
              }
              autoPlay
              muted
              loop
            /> : <img
              src={business?.imageBloqueBusiness ? business?.imageBloqueBusiness?.[0]?.url : ""}
              alt={
                business?.imageBloqueBusiness
                  ? business?.imageBloqueBusiness?.[0]?.alt
                  : business?.title
              }
              className="img-responsive zoomOut"
            />}
          </div>
          <div className="text-card-historico col-12 col-sm-12 col-md-6 col-lg-6">
            <header>
              <h2 className="id-section">{business?.bloqueTitle}</h2>
            </header>

            <p
              className="empresa-tiny-editor"
              dangerouslySetInnerHTML={{ __html: business?.bloqueDescription }}
            >
            </p>
          </div>
        </section>
      </div>
    </>
  );
}

export default EmpresaReplicaPGI;
